import React, { FunctionComponent } from "react";
import { styled } from "styled-components";

import * as gtag from "../../utils/gtag";
import { Device } from "@/utils/device";
import { Article } from "@/types/article/Article";
import PostArticleCard from "./PostArticleCard";
import { H2 } from "../Typography";

interface PostCarouselContentProps {
  articles: Article[];
  name: string;
  title: string;
}

const PostCarouselContent: FunctionComponent<PostCarouselContentProps> = (
  props
) => {
  const onClickArticle = () => {
    gtag.event({
      name: gtag.GA_EVENT.EDIT_ENGAGEMENT,
      category: "EDIT",
      label: "From home",
      value: props.title,
    });
  };

  return (
    <div>
      <H2>{props.title}</H2>
      <S.Container data-cy={`post-carousel-${props.name}`}>
        {props.articles.slice(1).map((article) => (
          <S.CarouselArticle key={article.sys.id}>
            <PostArticleCard
              {...article}
              flexDirection="column"
              imageWidth="100%"
              onClick={() => onClickArticle()}
            />
          </S.CarouselArticle>
        ))}
      </S.Container>
    </div>
  );
};

const S = () => {};

S.Container = styled.section`
  display: flex;
  gap: 2rem;
  padding: 2rem 1rem;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    height: 0px;
    width: 0px;
  }

  @media (min-width: ${Device.mobile}) {
    gap: 4rem;
  }
`;

S.CarouselArticle = styled.article`
  flex-shrink: 0;
  width: 250px;

  @media (min-width: ${Device.tablet}) {
    width: 300px;
  }
`;

export default PostCarouselContent;
